import registerModulesWithRouter from 'src/config/AccessControl/registerModulesWithRouter';
import BomModules from 'src/content/management/BOM/module';
import InventoryCachingModules from 'src/content/management/InventoryCaching/module';
import MaterialPlanningModules from 'src/content/management/MaterialPlanning/module';
import ProductModules from 'src/content/management/ItemGroup/module';
import ItemModules from 'src/content/management/Items/module';
import ProcessModules from 'src/content/management/Process/module';
import QRCodeGenerationModules from 'src/content/management/QRCodeGeneration/module';

const inventoryManagementRoutes = [
  registerModulesWithRouter(ItemModules),
  registerModulesWithRouter(ProductModules),
  registerModulesWithRouter(InventoryCachingModules),
  registerModulesWithRouter(MaterialPlanningModules),
  registerModulesWithRouter(BomModules),
  registerModulesWithRouter(ProcessModules),
  registerModulesWithRouter(QRCodeGenerationModules)
];

export default inventoryManagementRoutes;
